import { ApiStatus } from '../api/api-status.model';
import { AchPaymentMethod, CreditCardPaymentMethod } from './payment-account.model';

export interface AutoPayPayloadModel {
  payload: {
    autopayRule: {
      paymentAccountNickName: string;
      daysBeforeDueDate: string;
      paymentAmount: 'MINDUE' | 'FULLPAY';
    };
    lastUpdateTimestamp?: string;
  };
  action?: string;
  billAccountNumber: string;
  billAccountNickName: string;
  billAccountDueDate: string;
  hasScheduledPayment?: boolean;
  pendingScheduledPayment?: boolean;
  status?: ApiStatus;
  hasError?: boolean;
  correlationId: string;
}

export interface MultipleAutoPayPayloadModel {
  accounts: {
    billingNumber: string;
    paymentAccountNickName: string;
    daysBeforeDueDate: string;
    paymentAmount: string;
  }[];
}

export interface AutomaticPayment {
  billAccountNumber: string;
  daysBeforeDueDate: string;
  lastUpdateTimestamp: string;
  paymentAccount: {
    creditCard?: CreditCardPaymentMethod;
    achWithdrawal?: AchPaymentMethod;
    lastUpdateTimestamp?: string;
    nickName: string;
    paymentAccountId?: string;
    modeOfAuthorization?: string;
  };
  paymentAmount: 'MinDue' | 'FullPay';
  nextPaymentDate: string;
  predictedDollarAmount: string;
}

export interface MultipleAutoPayResponse {
  autoPayRules?: AutomaticPayment[];
  partialStatuses?: {
    payloadEntityId: string;
    status: ApiStatus;
  }[];
  status?: ApiStatus;
}

export class AutopayPredictPayloadModel {
  transactionId?: string;
  lastUpdateTimestamp?: string;
  autopayRule: {
    paymentAccountNickName: string;
    daysBeforeDueDate: number | string;
    paymentAmount: 'MINDUE' | 'FULLPAY';
  };
  predictionOnly: string | boolean;
  billAccountNumber?: string;
}
